export default __webpack_public_path__ + "static/media/logo-white.fa32a677.svg";